import { useTranslation } from 'react-i18next';

import { PageHeader } from 'components';
import { TranslationNamespace } from 'i18n';

import { P2PProviderPayinCustomerDailyLimitsList } from './P2PProviderPayinCustomerDailyLimitsList';

export const P2PProviderPayinCustomerDailyLimitsPage: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.p2p_provider_payin_customer_daily_limits',
  });

  return (
    <>
      <PageHeader title={t('title')} />
      <P2PProviderPayinCustomerDailyLimitsList />
    </>
  );
};
